import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'HOME', path: '/' },
    { name: 'ABOUT', path: '/about-us' },
    { name: 'SERVICES', path: '/services' },
    { name: 'BLOG', path: '/blog' },
    { name: 'CONTACT US', path: '/contact-us' },
  ];

  const serviceSubpages = [
    '/web-development',
    '/search-engine-optimization',
    '/search-engine-marketing',
    '/social-media-advertising',
    '/product-listing-ads'
  ];

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'auto';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className='nav_inner_div'>
        {/* Logo */}
        <div className={`nav_logo ${scrolled ? 'shrink' : ''}`}>
          <a href='./'>
            <img
              className='logo_img'
              src='./zweedo-logo-removebg.webp'
              alt='logo'
              loading='lazy'
            />
          </a>
        </div>

        {/* Nav Links */}
        <div className={`nav_links ${isOpen ? 'open' : ''}`}>
          {navItems.map((item) => {
            const isServiceSubpage = serviceSubpages.some((path) =>
              location.pathname.startsWith(path)
            );

            const isActive =
              item.path === '/'
                ? location.pathname === '/'
                : item.name === 'Services'
                ? location.pathname.startsWith(item.path) || isServiceSubpage
                : location.pathname.startsWith(item.path);

            return (
              <a key={item.name} href={item.path}>
                <li className={isActive ? 'active' : ''}>{item.name}</li>
              </a>
            );
          })}
        </div>

        {/* Hamburger */}
        <div
          className={`hamburger ${isOpen ? 'open' : ''}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className='bar'></span>
          <span className='bar'></span>
          <span className='bar'></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
